import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import EntregaForm from '../components/EntregaForm';
import EntregaEditarForm from '../components/EntregaEditarForm';
import FiltrosForm from '../components/FiltrosForm';
import moment from "moment-timezone";
import { getUsuario, getTemPermissao, getTipoUsuario } from "../utils/LoginManager";
import Colors from "../utils/Colors";

const { Column } = Table;
const ButtonGroup = Button.Group;


export default class extends Component {
  state = {
    listaRegistros: [],
    registro: '',
    eventStatus: '',
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdePedNSinc: 0,
    qtdePed: 0,
    qtdeOrc: 0,
    vlrTotalPed: 0,
    vlrTotalOrc: 0,
    qtdeEntregaPendente: 0,
    qtdeEntregaOK: 0,

    formFiltroVisivel: false,
    formEntregasVisivel: false,
    // formEditarVisivel: false,

    filtros: {
      tipoTela: 'PED',
      buscaOrdem: { campo: 'ven_dt_venda', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    getTipoUsuario().then(tipoUsuario => {
      this.state.filtros.buscaUsuario = {
        key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
      }
      this.setState({
        usuario,
        tipoUsuario,
      }, this.getListaRegistros);
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, qtdePed: 0, qtdeOrc: 0, qtdePedNSinc: 0, vlrTotalPed: 0, vlrTotalOrc: 0, qtdeEntregaPendente: 0, qtdeEntregaOK: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaMunicipio,
      buscaUsuario, buscaTipo, buscaOrdem } = this.state.filtros;

    let ven_dt_venda_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      ven_dt_venda_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let ven_dt_venda_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      ven_dt_venda_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/vendas', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          codCliente: buscaPessoa.key,
          cidade: buscaMunicipio.key,
          usuario: buscaUsuario.key,
          tipoVenda: buscaTipo.key,
          ven_dt_venda_ini,
          ven_dt_venda_fim,
          entrega: 1,
          print: 0,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.consulta;

        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          vlrTotalPed: response.data.vlrTotalPed,
          qtdePed: response.data.qtdePed,
          vlrTotalOrc: response.data.vlrTotalOrc,
          qtdeOrc: response.data.qtdeOrc,
          qtdePedNSinc: response.data.qtdePedNSinc,
          qtdeEntregaPendente: response.data.qtdeEntregaPendente,
          qtdeEntregaOK: response.data.qtdeEntregaOK,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (registro) => {
    this.setState({ salvando: true })

    // console.log('onSalvarClick: ', registro.ven_idf);
    // console.log('onSalvarClick: ', registro);
    // return;

    axios
      .put(`/vendas/updateEntregas/${registro.ven_idf}`, registro)
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formEntregasVisivel: false,
          salvando: false,
        })
        message.success('Entrega gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onCancelarClick = () => {
    this.setState({
      formEntregasVisivel: false,
    }, () => {
      this.getListaRegistros();
    });
  }

  // onCancelarEditarClick = () => {
  //   this.setState({
  //     formEditarVisivel: false,
  //   })
  // }



  onVizualizarClick = registro => {
    // console.log('onVizualizarClick 11');

    this.setState({ carregando: true });
    axios
      .get('/vendas/entregas', {
        params: {
          ven_idf: registro.ven_idf,
          print: 1,
        }
      })
      .then(response => {
        const { data } = response;

        // console.log('onVizualizarClick: ', data);

        if (data.consulta.length > 0) {
          this.setState({
            formEntregasVisivel: true,
            registroSelecionado: data.consulta,
            carregando: false,
          })
        } else {
          this.setState({
            carregando: false,
          })
          Modal.info({
            title: 'Entrega',
            content: 'Não foi possível localizar as entregas desse pedido',
            okText: 'OK',
          })
        }
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }









  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title={"Visualizar Entregas"}>
          <Button className="botoesModalFormVisualizar" size="small" onClick={() => this.onVizualizarClick(registro)} icon={"eye"} />
        </Tooltip>
      </ButtonGroup>
    );
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderCliente = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome}</span>
    );
  };

  renderMunicipio = (cmun_descricao, registro) => {
    return (
      <span style={{ fontSize: 11 }}>{cmun_descricao + '/' + registro.cuf_sigla}</span>
    );
  };

  renderStatus = (qtdeEntregas, registro) => {
    return (
      <div>
        <Tooltip title={!registro.qtdePendente ? "TODOS ITENS ENTREGUES" : registro.qtdeEntregas === registro.qtdePendente ? "NENHUM ITEM ENTREGUE" : "ENTREGA PARCIAL"}>
          <Icon type="clock-circle" style={{ marginRight: 5, color: !registro.qtdePendente ? "#10734a" : registro.qtdeEntregas === registro.qtdePendente ? "#b71c1c" : "#DEBF36" }} />
          <span style={{ fontSize: 11, color: !registro.qtdePendente ? "#10734a" : registro.qtdeEntregas === registro.qtdePendente ? "#b71c1c" : "#DEBF36" }}>{registro.qtdePendente ? 'PENDENTE' : 'ENTREGUE'}</span>
        </Tooltip>
      </div>
    );
  };

  renderUsuario = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome.substring(0, 10)}</span>
    );
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };







  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formEntregasVisivel, formEditarVisivel, salvando, registroSelecionado, registroEditarSelecionado, filtros, justificativa,
      total, pagina, limite, formFiltroVisivel, formJustfVisivel } = this.state;

    // console.log('EntregasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Controle de Entregas</h2>
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 70 }}>
          <Row>
            <Col xs={8} style={{ marginTop: -5 }}>
              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

            </Col>

            <Col xs={24} sm={10} style={{ marginTop: -15 }}>
              <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: "#e50000", color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Pendentes</span></Row>
                <Row><span>{this.state.qtdeEntregaPendente}</span></Row>
              </Col>
              <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Entregues</span></Row>
                <Row><span>{this.state.qtdeEntregaOK}</span></Row>
              </Col>
            </Col>

          </Row>

          <EntregaForm
            visivel={formEntregasVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          {/* <EntregaEditarForm
            visivel={formEditarVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarEditarClick={this.onCancelarEditarClick}
            carregando={salvando}
            registroEditarSelecionado={registroEditarSelecionado}
          /> */}
        </div>



        <div style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.ven_idf)}
          >
            <Column
              key="ven_numero"
              dataIndex="ven_numero"
              title={this.renderTitulo("Pedido")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ven_dt_venda"
              dataIndex="ven_dt_venda"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"13%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderCliente}
              width={"30%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="cmun_descricao"
              dataIndex="cmun_descricao"
              title={this.renderTitulo("Município")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderMunicipio}
              width={"20%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Vendedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"8%"}
              align="center"
              className="listaCadastro"
              render={this.renderUsuario}
            />
            <Column
              key="ven_tipo_venda"
              dataIndex="ven_tipo_venda"
              title={this.renderTitulo("Tipo")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="qtdeEntregas"
              dataIndex="qtdeEntregas"
              title={this.renderTitulo("Status")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderStatus}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>Ações</div>}
              render={this.renderAcoes}
              width={"20%"}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/EntregasPage.js